'use client';

import Link from 'next/link';

export default function JoinGrowthSchool() {
  return (
    <section className="w-full py-12 md:py-16">
      {/* Container with responsive width - 100% on mobile, 80% on desktop */}
      <div className="w-full md:w-[80%] mx-auto">
        {/* Main Card with Background Images */}
        <div className="relative w-full md:rounded-3xl overflow-hidden h-[500px] md:h-[330px]">
          {/* Desktop Background Image - Hidden on mobile */}
          <div 
            className="absolute inset-0 hidden md:block bg-cover bg-center" 
            style={{ 
              backgroundImage: 'url(https://d31bwppm8yl9g2.cloudfront.net/learner/website/jobd.webp)',
          
            }}
          />
          
          {/* Mobile Background Image - Hidden on desktop */}
          <div 
            className="absolute inset-0 md:hidden bg-cover bg-center" 
            style={{ 
              backgroundImage: 'url(https://d31bwppm8yl9g2.cloudfront.net/learner/website/jobm.png)',
     
            }}
          />
          
          {/* Dark overlay for better text visibility */}
          <div className="absolute inset-0 bg-[#002726]/50"></div>
          
          {/* Content Container */}
          <div className="relative z-10 h-full w-full flex flex-col justify-end md:justify-center p-6 md:p-10">
            {/* Mobile layout stacks content vertically and centers it */}
            <div className="md:w-1/2 text-white">
              <h2 className="text-3xl md:text-4xl font-medium mb-4">
                Interested in Joining Growth School?
              </h2>
              
              <p className="text-base md:text-lg text-white/90 mb-6">
                Be part of a thriving community of professionals and discover your next career move with us
              </p>
              
              <Link 
                href="https://sisinty.keka.com/careers" 
                className="inline-flex items-center bg-[#33c375] hover:bg-[#2ba764] text-[#012726] font-medium px-6 py-3 rounded-md transition-colors"
              >
                See Job openings
                <svg 
                  className="ml-2" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    d="M5 12H19M19 12L12 5M19 12L12 19" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}